import './Setup.scss';
import {ImportUserContextProvider} from "../../Users/ImportUsersModal/ImportUsersModalContext";
import {ImportUsersModal} from "../../Users/ImportUsersModal/ImportUsersModal";
import React from "react";
import { useNavigate} from "react-router-dom";
import { useUserAdminOrgs } from "../../Hooks/UseUserAdminOrgs";

export const Setup = () => {
    const [importUsersModalOpen, setImportUsersModalOpen] = React.useState(true)
    const { triggerReloadOrganizations } = useUserAdminOrgs({withAllOption: true, withCoursesAndSignDocs: false});
    const navigate = useNavigate()
    const openImportUsersModal = () => {
        setImportUsersModalOpen(true)
    }
    const closeImportUsersModal = () => {
        setImportUsersModalOpen(false)
        navigate(`/settings/general`, {replace: true})
    }

    const onSuccessCreateUsers = async () => {
        closeImportUsersModal()
        await triggerReloadOrganizations()
        navigate(`/learningManagement/users`, {replace: true})
    }
    return <div className="Setup">

        <ImportUserContextProvider>
            {importUsersModalOpen && <ImportUsersModal closeImportUsersModal={closeImportUsersModal}
                                                       importUserModalOpen={importUsersModalOpen}
                                                       onSuccessCreateUsers={onSuccessCreateUsers}/>}
        </ImportUserContextProvider>
    </div>
}